<template>
  <div v-loading="loading" style="height: calc(100% - 60px)">
    <div class="content-list" @click="detailData.activityName ? active = false : ''">
      <el-row>
        <el-col class="left" :span="3">活动名称：</el-col>
        <el-col class="right g-flex-start" :span="20">
          <span v-if="!active">{{ detailData.activityName }}</span>
          <el-input v-else v-model="detailData.activityName" @change="changeName" :maxlength="30" @click.stop.native size="small"></el-input>
          <img v-if="!active" src="../../../../assets/image/modify.png" @click.stop="active = true" alt="">
        </el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">创建时间：</el-col>
        <el-col class="right" :span="20">{{ detailData.createTime }}</el-col>
      </el-row>
      <el-row v-if="detailData.offlineTime">
        <el-col class="left" :span="3">下线时间：</el-col>
        <el-col class="right" :span="20">{{ detailData.offlineTime }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动油站：</el-col>
        <el-col class="right" :span="20">{{ detailData.gasName }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">手机号：</el-col>
        <el-col class="right" :span="20">{{ detailData.payeePhone }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">姓名：</el-col>
        <el-col class="right" :span="20">{{ detailData.payeeName }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">身份证号：</el-col>
        <el-col class="right" :span="20">{{ detailData.payeeCard }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">关联微信：</el-col>
        <el-col class="right" :span="20">{{ detailData.nickname }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动信息：</el-col>
        <el-col class="right" :span="20">{{ detailData.beginTime }} - {{ detailData.endTime }}</el-col>
      </el-row>
    </div>
    <div class="btn-groups" v-if="showButton">
      <el-button v-if="activeStatus === 1" class="btn-grey" @click="offline(4)">下线</el-button>
      <el-button v-if="activeStatus === 5" class="btn-grey" @click="offline(3)">取消</el-button>
      <el-button v-if="hasFinishStatus.includes(activeStatus)" @click="toReport">查看报表</el-button>
      <!-- <el-button v-if="hasFinishStatus.includes(activeStatus)">效果分析</el-button> -->
    </div>

    <el-dialog
      :title="`${state === 4 ? '下线' : '取消'}确认`"
      :visible.sync="dialogVisible"
      width="400px"
      top="20%"
      :center="true"
      append-to-body>
      <div class="g-flex-c tips-center">{{ offlineTips }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.stop="dialogVisible = false">算了</el-button>
        <el-button type="primary" @click.stop="userOfflineApi">{{ `确定${state === 4 ? '下线' : '取消'}` }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { changeName } from '@/api/marketShop'
import { getSendWaterDetail, offlineSendWater } from '@/api/marketShop/masterShouts'

export default {
  name: 'sendWaterDetail',
  props: ['detailType', 'id', 'show', 'activeStatus', 'showButton'],
  inject: ['resetData', 'getListData'],
  data () {
    return {
      active: false,
      detailData: {},
      regulationVos: [],
      loading: false,
      hasFinishStatus: [1,2,4], // 有效果分析、查看报表按钮的状态
      dialogVisible: false,
      offlineTips: '确定下线该活动吗',
      state: undefined
    }
  },
  methods: {
    // 初始化数据
    async initData () {
      this.loading = true
      try {
        const {code, result = {}} = await getSendWaterDetail({activityId: this.id})
        if (code !== 200) return
        this.detailData = result
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    // 修改活动名称
    async changeName () {
      if (!this.detailData.activityName) {
        this.$message({
          message: '请输入活动名称',
          type: 'warning'
        })
        return
      }

      this.$track.clickEvent('活动营销-活动列表-活动详情-修改名称', '1632832589')

      try {
        const {code} = await changeName({activeName: this.detailData.activityName, activeId: this.id})
        if (code !== 200) return
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.active = false
        this.resetData(this.detailType)
        this.getListData(this.detailType)
      } catch (error) {
        console.log(error)
      }
    },
    toReport () {
      this.$track.clickEvent('活动详情操作', '1632832590', {
        tysj_activity_type: 0,
        tysj_trade_type: 3
      })

      this.$parent.$parent.drawer = false
      this.$router.push({ path: '/bill/plantformBill' })
    },
    // 下线或取消送水活动
    offline (state) {
      this.$track.clickEvent('活动详情操作', '1632832590', {
        tysj_activity_type: 0,
        tysj_trade_type: state - 1
      })

      this.state = state
      this.dialogVisible = true
      this.offlineTips = `确定${state === 4 ? '下线' : '取消'}该活动吗`
    },
    async userOfflineApi (state) {
      try {
        const {code} = await offlineSendWater({activityId: this.id})
        if (code !== 200) return
        this.$message({
          message: `${state === 4 ? '下线成功' : '取消成功'}`,
          type: 'success'
        })
        location.reload()
        // this.resetData(this.data.activeType)
        // this.getListData(this.data.activeType)
      } catch (error) {
        console.log(error)
      }
    }
  },
  watch: {
    show (val) {
      val && this.initData()
      this.active = false
    }
  },
  mounted () {
    console.log(this.activeStatus, 'activeStatus')
    this.initData()
  }
}
</script>
<style lang="less" scoped>
  @import url('./style.less');
</style>